module.exports = __webpack_public_path__ + "img/Logo8i.14b841c7.png";